<div mat-dialog-header class="title">
	Device
</div>
<div mat-dialog-content>
	<div class="flex-column">
		<div *ngIf="loadingClients" class="container centered-content">
			<mat-spinner strokeWidth="2" [diameter]="20"></mat-spinner>
		</div>
		<autocomplete-dropdown 
		    *ngIf="!loadingClients"
			[options]="clients$ | async" 
			[selectedValue]="client"   			
			[label]="'Client'"
			[displayWith]="clientDisplayWith"
			(selectionChange)="onClientSelected($event)"> 			
		</autocomplete-dropdown>
		<!--  Site selector -->
		<div *ngIf="loadingSites" class="container centered-content">
			<mat-spinner strokeWidth="2" [diameter]="20"></mat-spinner>
		</div>
		<mat-form-field *ngIf="!loadingSites">
			<mat-label>Site</mat-label>
			<mat-select [(ngModel)]="siteId">
				<mat-option *ngFor="let s of siteOptions" [value]="s.id">
					{{ s.name }}
				</mat-option>
			</mat-select>
		</mat-form-field>
		<mat-form-field>
			<mat-label>Type</mat-label>
			<mat-select [(ngModel)]="type">
				<mat-option *ngFor="let item of typeOptions" [value]="item[0]">
					{{item[1]}}
				</mat-option>
			</mat-select>
		</mat-form-field>
		<mat-form-field>
			<mat-label>Name</mat-label>
			<input matInput type="text" [(ngModel)]="name"/>
		</mat-form-field>
		<mat-form-field>
			<mat-label>Notes</mat-label>
			<textarea matInput [(ngModel)]="notes"></textarea>
		</mat-form-field>
		<mat-form-field>
			<mat-label>Tolerance Alert</mat-label>
			<measurement-input type="particleSize" [unitSystem]="(particleSizeUnitSystem$|async)" [(ngModel)]="threshold"></measurement-input>
		</mat-form-field>
		<mat-form-field>
			<mat-label>Slabs Diameter</mat-label>
			<measurement-input type="particleSize" [unitSystem]="(particleSizeUnitSystem$|async)" [(ngModel)]="slabDiameter"></measurement-input>
		</mat-form-field>
		<mat-form-field>
			<mat-label>Density</mat-label>
			<measurement-input type="largeDensity" [unitSystem]="(quantityUnitSystem$|async)" [(ngModel)]="density"></measurement-input>
		</mat-form-field>
		<mat-form-field>
			<mat-label>Alert Email</mat-label>
			<input matInput type="text" [(ngModel)]="alertEmail">
		</mat-form-field>
	</div>
</div>
<div mat-dialog-actions>
	<button mat-button (click)="cancel()">Cancel</button>
	<button mat-flat-button color="primary" [disabled]="!valid()" (click)="save()">Save</button>
</div>